import { padLeft } from './common.js';

/**
 * 初始化流程滾動特效
 */
export function initProcessScroll() {
  const $listNum = document.querySelector('.list-num');
  const $wrapper = $listNum?.nextElementSibling;
  const $articles = document.querySelectorAll('.pages-artical');

  if (!$wrapper || !$articles.length || !$listNum) return;

  const $currentNumDisplay = $listNum.children[0];
  const $totalNumDisplay = $listNum.children[2];
  const $progressBar = $listNum.querySelector('.progress-bar');

  if (!$progressBar) return;

  // 設定總數
  const totalCount = $articles.length;
  $totalNumDisplay.textContent = padLeft(totalCount, 2);

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  // ==========================================
  // 進度條初始化
  // ==========================================
  const unitPercent = 100 / totalCount;
  gsap.set($progressBar, {
    height: `${unitPercent}%`,
    top: 0
  });

  const first = $articles[0];
  const last = $articles[$articles.length - 1];

  // ==========================================
  // [核心修正] 絕對座標定位邏輯
  // ==========================================

  // 輔助函式：遞迴計算元素距離 document 頂部的絕對位置
  const getAbsoluteTop = (element) => {
    let top = 0;
    while (element) {
      top += element.offsetTop;
      element = element.offsetParent;
    }
    return top;
  };

  // 預先抓取最後一張卡片元素 (DOM 元素不會變，變的是高度)
  let lastCards = Array.from(last.children).filter(child => child.tagName === 'SECTION');
  if (lastCards.length === 0) {
    lastCards = last.querySelectorAll('section');
  }
  const lastInnerCard = lastCards.length > 0 ? lastCards[lastCards.length - 1] : null;
  const firstInnerCard = first.querySelector('section');

  // ==========================================
  // ScrollTrigger 設定
  // ==========================================
  
  // 3. 設定側邊欄初始位置 (初次計算)
  // 雖然 ScrollTrigger 會接手，但先設定好初始位置避免閃爍
  if (firstInnerCard) {
      const wrapperAbsTop = getAbsoluteTop($wrapper);
      const initStartOffset = (getAbsoluteTop(firstInnerCard) - wrapperAbsTop) + (firstInnerCard.offsetHeight / 2);
      gsap.set($listNum, {
        top: initStartOffset,
        yPercent: -50
      });
  }

  const st = ScrollTrigger.create({
    trigger: $wrapper,
    pin: $listNum,
    
    // [重點修正]：將計算邏輯放入函式中，確保每次 Refresh 都重新計算最新的高度
    start: () => {
      if (!firstInnerCard) return "top top";
      const wrapperAbsTop = getAbsoluteTop($wrapper);
      // 實時計算 Start Offset
      const currentStartOffset = (getAbsoluteTop(firstInnerCard) - wrapperAbsTop) + (firstInnerCard.offsetHeight / 2);
      return "top+=" + currentStartOffset + " center";
    },

    end: () => {
      let currentEndOffset = 0;
      if (lastInnerCard) {
        const wrapperAbsTop = getAbsoluteTop($wrapper);
        // [重點] 實時計算 End Offset (此時圖片若撐開，getAbsoluteTop 會變大)
        const lastCardAbsTop = getAbsoluteTop(lastInnerCard);
        currentEndOffset = (lastCardAbsTop - wrapperAbsTop) + (lastInnerCard.offsetHeight / 2);
      } else {
        currentEndOffset = $wrapper.offsetHeight;
      }
      return "top+=" + currentEndOffset + " center";
    },

    pinSpacing: false,
    invalidateOnRefresh: true // 必須開啟，讓 start/end 函式在刷新時重新執行
  });

  // ==========================================
  // 監聽與刷新機制
  // ==========================================

  // 1. 針對 Wrapper 內所有圖片監聽載入
  const imgs = $wrapper.querySelectorAll("img");
  imgs.forEach(img => {
    if (!img.complete) {
      // 使用 GSAP 內建的防抖動刷新，效能較好
      img.addEventListener("load", () => ScrollTrigger.refresh());
    }
  });
  
  // 2. 使用 ResizeObserver 監控 Wrapper 高度變化
  if (window.ResizeObserver) {
    const ro = new ResizeObserver(() => {
      ScrollTrigger.refresh();
    });
    ro.observe($wrapper);
  }

  // 3. 全域 Load 確保萬無一失
  window.addEventListener("load", () => {
    ScrollTrigger.refresh();
  });

  // ==========================================
  // 更新狀態函式 (長度變化)
  // ==========================================
  $articles.forEach((article, index) => {
    ScrollTrigger.create({
      trigger: article,
      start: "top center",
      end: "bottom center",
      onEnter: () => updateStatus(index),
      onEnterBack: () => updateStatus(index)
    });
  });

  function updateStatus(index) {
    $currentNumDisplay.textContent = padLeft(index + 1, 2);
    const newHeight = (index + 1) * unitPercent;
    gsap.to($progressBar, {
      height: `${newHeight}%`,
      duration: 0.3,
      ease: "power2.out"
    });
  }
}